























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import VueScroller from "vue-scroller";
import { isIos } from "@/utils/lodash";

Vue.use(VueScroller);
@Component({
  components: {}
})
export default class ScrollView extends Vue {
  @Prop({ default: false })
  private isPullDown?: boolean; //是否开启下拉刷新
  @Prop({ default: false })
  private isPullUp?: boolean; //是否开启上拉加载
  @Prop({ default: false })
  private orderPullUp?: boolean; //是否是order也上啦加载
  @Prop({
    default: () => {}
  })
  private onPullingDown?: (fn?: any) => {};
  @Prop({
    default: () => {}
  })
  private onPullingUp?: (fn?: any) => {};

  private refreshText: string = "Pull to refresh";
  private noDataText: string = "You’ve reached the end";

  private isCanRefresh = true;
  private noOpacity = false;
  private translateY = 0;
  private touchSartPos = 0;
  private isLoadEnded = false;
  private showInfiniteSpinner = false;
  private scrollLoad = true;
  private touchStartX = 0;
  private touchStartY = 0;

  get scrollRef() {
    return this.$refs.scroll ? (this.$refs.scroll as any) : false;
  }

  get isIos() {
    return isIos();
  }

  public pullUpDone(done?: any) {
    this.$nextTick(() => {
      this.scrollLoad = true;
      this.showInfiniteSpinner = false;
      if (done) {
        this.showInfiniteSpinner = true;
        this.isLoadEnded = true;
      }
    });
  }

  public pullDownDone() {
    this.translateY = 0;
    this.isCanRefresh = true;
  }

  private touchstartEvent(e: any) {
    const touchTarget: any = e.touches[0];
    this.touchStartY = touchTarget.clientY;
    this.touchStartX = touchTarget.clientX;
  }

  private touchmoveEvent(e: any) {
    const touchTarget: any = e.touches[0];
    const offsetX = touchTarget.clientX - this.touchStartX;
    const offsetY = touchTarget.clientY - this.touchStartY;

    // 避免上下滚动的同时出现左右滑动,如果是左右滑动，就不执行下拉刷新或者上拉加载
    if (Math.abs(offsetY) >= Math.abs(offsetX)) {
      e.stopPropagation();
    }
  }

  private scrollTo() {
    this.scrollRef.scrollTo();
  }

  // private touchmoveEvent(evevt: any) {
  //   if(event) {
  //     console.log(event.touches)
  //   }
  // }

  // get getPosition() {
  //   console.log("getPosition", this.scrollRef);
  //   return this.scrollRef ? this.scrollRef.getPosition() : null;
  // }

  // @Watch("getPosition", { immediate: false })
  // private changePosition(val: any, oldVal: any) {
  //   this.$emit("onScroll", val);
  // }

  get onPullingFn() {
    if (this.isPullDown || this.isPullUp) {
      if (this.isPullDown && this.isPullUp) {
        return {
          "on-refresh": this.onPullingDown,
          "on-infinite": this.onPullingUp
        };
      } else if (this.isPullDown) {
        return { "on-refresh": this.onPullingDown };
      } else {
        return { "on-infinite": this.onPullingUp };
      }
    }
  }

  @Watch("isPullUp", { immediate: true })
  private registAndoridPullUpEvent() {
    if (this.isIos || !this.isPullUp) {
      return;
    }
  }

  @Watch("isPullDown", { immediate: true })
  private registAndoridPullDownEvent() {
    if (!this.isIos && this.isPullDown) {
      this.androidPullDown();
    }
  }

  private androidPullDown() {
    this.$nextTick(() => {
      const andordView = this.$refs.andriodView as HTMLElement;
      const touchStart = (event: any) => {
        this.touchSartPos = event.touches[0].pageY;
        this.noOpacity = false;
      };
      const touchMove = (event: any) => {
        const scrollTop = andordView.scrollTop;
        const touchMoveDistanc = event.touches[0].pageY - this.touchSartPos;
        if (scrollTop <= 0 && touchMoveDistanc > 15) {
          this.noOpacity = true;
          if (this.translateY <= 120) {
            this.translateY += 15;
          }
          if (this.translateY >= 70) {
            this.noOpacity = true;
            if (this.isCanRefresh) {
              this.isCanRefresh = false;
            }
          }
        }
      };
      const touchEnd = () => {
        this.translateY = this.translateY >= 100 ? 100 : 0;
        this.touchSartPos = 0;
        //松开手指后刷新
        if (!this.isCanRefresh) {
          // 开始刷新
          this.onPullingDown && this.onPullingDown(this.pullDownDone);
        }
      };
      if (andordView) {
        andordView.addEventListener("touchstart", touchStart, false);
        andordView.addEventListener("touchmove", touchMove, false);
        andordView.addEventListener("touchend", touchEnd, false);
      }
    });
  }
}
